import store from '../../store'
import filter from 'lodash/filter'

export function getProjectConnectionsForMeeting(meetingId) {   
  const state = store.getState()
  const connections = filter(state.meetingProjectConnections, {meeting: meetingId});
  return connections;
}
